/**
 * Created by guntherclaes on 09/05/2017.
 */
var visionText = angular.module('visionText', []);

visionText.directive('visionText', require('./js/visionText/visionText'));
visionText.directive('organisationName', require('./js/organisationName/organisationName'));
visionText.directive('visionTextCollapsedContent', require('./js/collapsedContent/collapsedContent'));
visionText.directive('visionTextImage', require('./js/image/image'));
visionText.directive('visionTextImageGroup', require('./js/imageGroup/imageGroup'));
visionText.directive('visionTextParagraph', require('./js/paragraph/paragraph'));
visionText.directive('visionTextReferenceWidget', require('./js/referenceWidget/referenceWidget'));
visionText.directive('visionTextSection', require('./js/section/section'));
visionText.directive('visionTextReferenceButton', require('./js/referenceButton/referenceButton'));

module.exports = visionText;



// WEBPACK FOOTER //
// ./web/js/module/visionText/index.js